import { Component, OnDestroy } from '@angular/core';
import { ReportsService } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';
import { ValueTextObject } from 'src/app/model/user';
import { Subscription } from 'rxjs';

interface ManualSubscriptions {
  commonReportChangedOnLoad: Subscription;
  pageChanged: Subscription;
  driverPerformanceDialogClosed: Subscription;
}

@Component({
  selector: 'vrm-report-data-nav',
  templateUrl: './report-data-nav.component.html',
  styleUrls: ['./report-data-nav.component.scss'],
})
export class ReportDataNavComponent implements OnDestroy {
  flagExistsInMeta: boolean = false;
  dataNavVisible: boolean = false;
  dataFilterOptions: Array<ValueTextObject> = [];

  selectedFilterData: ValueTextObject;
  filterType: string;
  currentReport: string;

  currentIndex: number = 0;
  maxIndex: number;
  minIndex: number = 0;

  manualSubscriptions: ManualSubscriptions = {
    commonReportChangedOnLoad: null,
    pageChanged: null,
    driverPerformanceDialogClosed: null,
  };

  constructor(private rptService: ReportsService, public cService: CommonService) {
    this.manualSubscriptions.commonReportChangedOnLoad = this.rptService.commonReportDataChangedOnLoad$.subscribe({
      next: () => {
        this.dataNavVisible = false;

        const options = this.getOptions();

        if (options.length) {
          this.dataFilterOptions = options;

          if (!this.selectedFilterData) {
            this.selectedFilterData = this.dataFilterOptions[0];
            this.maxIndex = this.dataFilterOptions.length - 1;
            this.filterType = this.rptService.currentReportMeta.singleServerFilter.key;
          }

          this.currentReport = this.cService.navigatedReport.navigationData.translatedName;
          this.dataNavVisible = true;

          if (
            this.rptService.currentReportMeta.singleServerFilter.fromUserProfile &&
            this.dataFilterOptions.length < 2
          ) {
            this.dataNavVisible = false;
          }
        }
      },
    });

    this.manualSubscriptions.pageChanged = this.cService.pageChangedNavEnd$.subscribe({
      next: () => {
        this.selectedFilterData = null;
      },
    });

    this.manualSubscriptions.driverPerformanceDialogClosed = this.rptService.driverPerformanceDialogClosed$.subscribe({
      next: () => this.resetToDefault(),
    });
  }

  private resetToDefault() {
    const options = this.getOptions();

    if (options.length) {
      this.selectedFilterData = this.dataFilterOptions[0];
    }
  }

  dataFilterChanged(selectedFilter: ValueTextObject, selectedIndex: number) {
    this.currentIndex = selectedIndex;
    this.selectedFilterData = selectedFilter;
    this.applySelectedFilter();
  }

  nextData() {
    this.currentIndex = this.cService.navigateNext(this.currentIndex, this.maxIndex);
    this.selectedFilterData = this.dataFilterOptions[this.currentIndex];
    this.applySelectedFilter();
  }

  prevData() {
    this.currentIndex = this.cService.navigatePrev(this.currentIndex, this.minIndex);
    this.selectedFilterData = this.dataFilterOptions[this.currentIndex];
    this.applySelectedFilter();
  }

  private applySelectedFilter() {
    this.rptService.requestedServerFilters[this.filterType] = [this.selectedFilterData.value];
    this.rptService.triggerServerFilterChangedObservable(true);
  }

  ngOnDestroy() {
    for (const sub in this.manualSubscriptions) {
      if (this.manualSubscriptions[sub]) {
        this.manualSubscriptions[sub].unsubscribe();
      }
    }
  }

  private getOptions() {
    const flagExistsInMeta =
      this.rptService.currentReportMeta &&
      this.rptService.currentReportMeta.singleServerFilter &&
      ((this.rptService.currentReportMeta.singleServerFilter.options &&
        this.rptService.currentReportMeta.singleServerFilter.options.length) ||
        (this.rptService.currentReportMeta.singleServerFilter.fromUserProfile &&
          this.rptService.currentReportMeta.singleServerFilter.userProfileKey.length &&
          this.cService.userProfile[this.rptService.currentReportMeta.singleServerFilter.userProfileKey].length));

    if (!flagExistsInMeta) {
      return [];
    }

    if (this.rptService.currentReportMeta.singleServerFilter.options != null) {
      return this.rptService.currentReportMeta.singleServerFilter.options;
    }

    if (this.rptService.currentReportMeta.singleServerFilter.fromUserProfile) {
      const options = [
        ...this.cService.userProfile[this.rptService.currentReportMeta.singleServerFilter.userProfileKey],
      ];

      if (this.rptService.currentReportMeta.singleServerFilter.excludeKey) {
        const key = this.rptService.currentReportMeta.singleServerFilter.excludeKey;
        const excludeKeyIndex = options.indexOf(key);
        if (excludeKeyIndex >= 0) {
          options.splice(excludeKeyIndex, 1);
        }
      }

      return options
        .map((value) => {
          return {
            text: this.cService.readyTranslations.courses[value]
              ? this.cService.readyTranslations.courses[value]
              : this.cService.getTextFromNavigationFilterTexts(value),
            value: value,
          };
        })
        .sort((a: any, b: any) => {
          if (a['text'] > b['text']) {
            return 1;
          } else if (a['text'] < b['text']) {
            return -1;
          } else {
            return 0;
          }
        });
    }

    return [];
  }
}
